var SiteSearch = {
    itemsPerPage: 12,
    SearchType: "",
    initialSearch: true,
    searchParams: null,
    renderPartial: null,

    me: this,

    // Init - Called from the script Utils.AddScript() tag in the template
    InitSiteSearch: function (hasSearchTerm, _itemsPerPage, _renderPartial) {
        this.SearchType = "SiteSearch";

        if (isEmptyOrSpaces(_renderPartial)) {
            alert('Need to pass in the partial name that will render the result');
            return;
        }
        this.renderPartial = _renderPartial;

        if (_itemsPerPage !== undefined && _itemsPerPage !== null && parseInt(_itemsPerPage) > 0) {
            this.itemsPerPage = parseInt(_itemsPerPage);
        }

        if (hasSearchTerm === true) {
            this.initialSearch = false;  // Prevent a keyword from the query string from being overwritten
        }

        var prom = this.GetSearchResults(1);
        prom.then(
            function (result) {
                console.log("Search results : %o", result);

                $('#search__results').html(result.htmlResults);

                $('#pagination_search').pagination({
                    items: result.totalResultCount,
                    itemsOnPage: this.itemsPerPage,
                    cssStyle: 'light-theme',
                    onPageClick: function (pageNumber, event) {
                        this.DoAjaxSearch(pageNumber);
                        scrollToAnchorIDOffset('topOfSearch'); ('topOfSearch');
                    }.bind(this),
                    onInit: function () {
                        console.log('Init paging');
                        var resultCount = 0;
                        if (result.totalResultCount !== null) {
                            resultCount = result.totalResultCount;
                        }
                        this.DoPagination(resultCount, 1);
                    }.bind(this)
                });
            }.bind(this)
        );

        $('#siteSearchButtonSearch').click(function (event) {
            event.preventDefault();
            this.DoAjaxSearch(1);
        }.bind(this));
        $('#siteSearchButtonClear').click(function (event) {
            event.preventDefault();
            this.ClearSiteSearch(); s
        }.bind(this));

        $('#searchboxSite').keypress(function (event) {
            var keycode = event.keyCode ? event.keyCode : event.which;
            if (keycode === '13') {
                this.DoAjaxSearch(1);
            }
        }.bind(this));

        // Add events for checkboxes
        $(".search__aggregation input[type='checkbox']").click(function () {
            this.DoAjaxSearch(1);
        }.bind(this));

        document.getElementById("searchboxSite").addEventListener("search", function (event) {
            this.DoAjaxSearch(1);
        }.bind(this));
    },

    ClearSiteSearch: function () {
        // Uncheck all the boxes
        //$('.search__aggregation input[type=checkbox]').prop('checked', false);
        $('.search__aggregation input[type=checkbox]').removeAttr('checked');
        $('.search__aggregation .search__aggregation-icon').removeClass('search__aggregation-icon--active');

        // Recheck the Content type boxes
        $('.search__aggregation input[type=checkbox][data-group="ContentType"]').prop('checked', 'checked');

        this.DoAjaxSearch(1);
    },

    // The following groups are called by convention using searchType  e.g. 'populate' + SearchType + '()'
    PopulateSiteSearch: function (fieldsObj) {
        console.log('Populate form from cookie object : %o', fieldsObj);
        $('#searchboxSite').val(fieldsObj.keywords);

        // Checked by default so in this case we need to disable all then apply the saved ones
        $('input[type=checkbox][data-group="ContentType"]').prop('checked', '');
        this.checkBoxesByValue(fieldsObj.contentType);

        this.checkBoxesByValue(fieldsObj.audience);
        this.checkBoxesByValue(fieldsObj.health);
        this.checkBoxesByValue(fieldsObj.services);
    },

    // Takes an array of values and checks the corresponding boxes
    CheckBoxesByValue: function (arrayOfValues) {
        if (typeof arrayOfValues !== 'undefined') {
            if (arrayOfValues.length > 0) {
                for (var i = 0; i < arrayOfValues.length; i++) {
                    $('input[type=checkbox][value="' + arrayOfValues[i] + '"]').prop('checked', 'checked');
                }
            }
        }
    },

    // Some boxes are ticked by default and we need to untick
    UncheckBoxesByValue: function (arrayOfValues) {
        if (typeof arrayOfValues !== 'undefined') {
            if (arrayOfValues.length > 0) {
                for (var i = 0; i < arrayOfValues.length; i++) {
                    $('input[type=checkbox][value="' + arrayOfValues[i] + '"]').prop('checked', 'checked');
                }
            }
        }
    },

    DoPagination: function (resultCount, currentPage) {
        var $pagination = $('#pagination_search');

        console.log('Page results count : %o - Per page : %o', resultCount, this.itemsPerPage);

        if (resultCount !== null && resultCount > this.itemsPerPage) {
            $pagination.pagination('destroy');
            $pagination.pagination('updateItems', resultCount);
            $pagination.pagination('drawPage', currentPage);
            $pagination.show();
        } else {
            $pagination.hide();
        }
    },
    DoAjaxSearch: function (pageNo) {
        var prom = this.GetSearchResults(pageNo);
        prom.then(
            function (result) {
                console.log("Processing ajax results : %o", result);

                $('#search__results').html(result.htmlResults);

                this.DoPagination(result.totalResultCount, pageNo);

                scrollToAnchorIDOffset('topOfSearch');
            }.bind(this)
        );
    },

    // Do our ajax call to fetch the results
    GetSearchResults: function (pageNo, rootNode) {
        return new Promise(function (resolve, reject) {
            //var searchParams = null;
            var paramSource = "";

            // If we have a cookie use that object to search and populate the form
            if (this.initialSearch === "disabled" && Cookies.get(SearchType)) {
                // Get from cookie
                paramSource = "cookie";
                searchParams = JSON.parse(Cookies.get(SearchType));
                // default
                searchParams.rootNodeId = rootNode;
                var fn = window['this.populate' + SearchType];
                if (typeof fn === "function") {
                    fn(searchParams);
                } else {
                    console.error('Missing populate function %o so can\'t populate form', 'populate' + SearchType);
                }
            } else {
                // Default
                paramSource = "fields";
                searchParams = this.BuildSiteSearchParams(pageNo);
            }

            console.log('GetSearchResults with %o searchParams : %o', paramSource, searchParams);
            this.initialSearch = false;

            fetch('/umbraco/surface/siteSearch/DoSiteSearchView', {
                body: JSON.stringify(searchParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
                .then(function (response) {
                    //console.log('response : %o', response.json());
                    resolve(response.json());
                })
                .catch(error => {
                    console.log('Failed', error);
                    reject(error);
                });
        }.bind(this));
    },

    FilterToArray: function (collection) {
        var result = new Array();
        var length = collection.length;

        for (var j = 0; j < length; j++) {
            result.push($(collection[j]).val());
        }

        return result;
    },

    BuildSiteSearchParams: function (pageNo) {
        searchParams = {};
        searchParams.currentResultPage = pageNo;

        searchParams.partialView = this.renderPartial;

        // Keywords
        if ($('#searchboxSite').val() !== '') {
            searchParams.keywords = $('#searchboxSite').val();
        }
        console.log("Keywords: " + document.getElementById('searchboxSite').value);
        // Specific doc type(s) - Can be used to create a news or event only listing
        if ($('#searchSpecificDocType').val() !== '') {
            searchParams.searchSpecificDocType = $('#searchSpecificDocType').val();
        }

        // content type : "content" or "media"  - (empty = both)
        if ($('#searchContentType').val() !== null && $('#searchContentType').val() !== '') {
            searchParams.contentTypeCorM = $('#searchContentType').val();
        }

        // Root node restriction . e.g. publications only look in the archive folder
        var rnv = $('#rootNode').val();
        if (rnv !== null && rnv !== '' && rnv !== undefined) {
            searchParams.rootNodeId = $('#rootNode').val();
        }

        // Date filter target field
        if ($('#dateFilterField').val() !== null && $('#dateFilterField').val() !== '') {
            searchParams.dateFilterField = $('#dateFilterField').val();
        }

        // Results order
        if ($('#orderField').val() !== null && $('#orderField').val() !== '') {
            searchParams.orderField = $('#orderField').val();
        }

        // Results per page
        //if ($('#resultsPerPage').val() !== null && $('#resultsPerPage').val() !== '') {
        //    searchParams.resultsPerPage = $('#resultsPerPage').val();
        //}
        searchParams.resultsPerPage = this.itemsPerPage;

        /// =================================
        /// Custom taxonomy
        /// =================================

        // People
        var checks = $("input[type='checkbox'][data-group='people']");
        if (checks.length) {
            searchParams.people = nodeListToIds(checks);
        }

        if (!isEmptyOrSpaces($('#startDate').val()) && !isEmptyOrSpaces($('#endDate').val())) {
            searchParams.startDate = $('#startDate').val();
            searchParams.endDate = $('#endDate').val();
        }

        // Save a cookie
        if (this.SearchType === "") {
            console.log('Search type not set so no cookie name available');
        } else {
            console.log('Setting %o cookie to %o', this.SearchType, searchParams);
            Cookies.set(this.SearchType, searchParams, {
                //expires: 1 - Session cookie
            });
        }

        return searchParams;
    }
}